import * as React from "react";

function IcContactPhone(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcContactPhone"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80036 19.7258C3.46696 19.3858 3.03107 17.1045 4.1005 16.183L7.65247 13.3381C8.09605 12.9559 8.39008 13.2226 8.72756 13.6772C9.81865 15.147 10.4953 16.8592 12.6166 14.7379L14.738 12.6166C16.8593 10.4953 15.1471 9.81862 13.6773 8.72749C13.2227 8.39002 12.9561 8.09583 13.3383 7.65226L16.1829 4.10054C17.1044 3.0311 19.3859 3.46689 19.7258 4.80029C20.5004 6.85414 21.4555 11.5559 16.5058 16.5056C11.556 21.4554 6.92543 20.4291 4.80036 19.7258Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IcContactPhone;
